import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

/**
 * Komponenta pro odeslání žádosti do DS
 * */
@Component({
	selector: 'app-isds-button',
	templateUrl: './isds-button.component.html',
	styleUrls: ['./isds-button.component.css'],
	imports: [ButtonModule, DialogModule, ProgressSpinnerModule, CommonModule, FormsModule],
	standalone: true
})
export class IsdsButtonComponent {

	constructor() { }

	_block: boolean = false;

	@Input()
	set block(value: boolean) {
		this._block = value;
	}
	get block(): boolean {
		return this._block;
	}

	@Output()
	buttonClicked: EventEmitter<any> = new EventEmitter();

	/**
	 * Handler kliku na tlačítko
	 * */
	onClick(): void {
		this.buttonClicked.emit();
	}
}
